module.exports = {
          srcSet: __webpack_public_path__ + "public/images/16017140270343d95160bb2f72b75d38-380.jpg"+" 380w",
          images:[ {path: __webpack_public_path__ + "public/images/16017140270343d95160bb2f72b75d38-380.jpg",width: 380,height: 253}],
          src: __webpack_public_path__ + "public/images/16017140270343d95160bb2f72b75d38-380.jpg",
          toString:function(){return __webpack_public_path__ + "public/images/16017140270343d95160bb2f72b75d38-380.jpg"},
          
          width: 380,
          height: 253
        }